declare class PNGlib {
    constructor(w: Number, h: Number, depth: Number);
    color(r:Number, g:Number, b:Number, a?:Number): Number;
    buffer: Number[];
    getBase64(): string;
    index(i: Number, j: Number): number;
};


export enum SidingType {
	SelectSiding,
	Trim,
    BoardBatten,
    Double4,
    Double5,
    DutchLap,
    Shake,
    Shingle,
    Single8
}

export enum SidingArea {
	Trim,
	A,
	B,
	C
}

export enum SidingColor {
    None = -1,
	BrickRed,
	Brownstone,
	Caramel,
	Chocolate,
	ColonialBlue,
	DustyClay,
	Ebony,
	Eggshell,

	EmberGray,

	Goldenrod,
	SilverGray,
	LibertyGray,
	Moccasin,
	Mocha,
	MountainGreen,
	NorthernWoods,
	OliveBranch,
	Rattan,
	Sandalwood,
	Sienna,
	SnowWhite,
	SunsetRed,
	TerraBronze,
	WinterSage,
	DeepOceanBlue,
	GrayWolf
}
export var trimColors = [
	SidingColor.None,
	SidingColor.BrickRed,
	SidingColor.Brownstone,
	SidingColor.Caramel,
	SidingColor.Chocolate,
	SidingColor.ColonialBlue,
	SidingColor.DustyClay,
	SidingColor.Ebony,
	SidingColor.Eggshell,

	SidingColor.EmberGray,

	SidingColor.Goldenrod,
	SidingColor.SilverGray,
	SidingColor.LibertyGray,
	SidingColor.Moccasin,
	SidingColor.Mocha,
	SidingColor.MountainGreen,
	SidingColor.NorthernWoods,
	SidingColor.OliveBranch,
	SidingColor.Rattan,
	SidingColor.Sandalwood,
	SidingColor.Sienna,
	SidingColor.SnowWhite,
	SidingColor.SunsetRed,
	SidingColor.TerraBronze,
	SidingColor.WinterSage
];

export var shakeSidingColors = [
	SidingColor.BrickRed,
	SidingColor.Caramel,
	SidingColor.Chocolate,
	SidingColor.ColonialBlue,
	SidingColor.DeepOceanBlue,
	SidingColor.DustyClay,
	SidingColor.GrayWolf,
	SidingColor.NorthernWoods,
	SidingColor.OliveBranch,
	SidingColor.Sienna,
	SidingColor.TerraBronze
];

export var shingleSidingColors = [
	SidingColor.Chocolate,
	SidingColor.DeepOceanBlue,
	SidingColor.DustyClay,
	SidingColor.Goldenrod,
	SidingColor.GrayWolf,
	SidingColor.LibertyGray,
	SidingColor.NorthernWoods,
	SidingColor.OliveBranch,
	SidingColor.SunsetRed,
	SidingColor.TerraBronze,
	SidingColor.WinterSage
];

export var singleDoubleColors = [
	SidingColor.None,
	SidingColor.BrickRed,
	SidingColor.Brownstone,
	SidingColor.Caramel,
	SidingColor.Chocolate,
	SidingColor.ColonialBlue,
	SidingColor.DeepOceanBlue,
	SidingColor.DustyClay,
	SidingColor.Eggshell,

	SidingColor.EmberGray,

	SidingColor.Goldenrod,
	SidingColor.GrayWolf,
	SidingColor.SilverGray,
	SidingColor.LibertyGray,
	SidingColor.Moccasin,
	SidingColor.Mocha,
	SidingColor.MountainGreen,
	SidingColor.NorthernWoods,
	SidingColor.OliveBranch,
	SidingColor.Rattan,
	SidingColor.Sandalwood,
	SidingColor.Sienna,
	SidingColor.SnowWhite,
	SidingColor.SunsetRed,
	SidingColor.TerraBronze,
	SidingColor.WinterSage
];

export var dutchLapColors = [
    SidingColor.None,
	SidingColor.Caramel,
	SidingColor.DeepOceanBlue,
	SidingColor.DustyClay,
	SidingColor.Eggshell,

	SidingColor.EmberGray,

	SidingColor.Goldenrod,
	SidingColor.GrayWolf,
	SidingColor.SilverGray,
	SidingColor.Moccasin,
	SidingColor.Mocha,
	SidingColor.NorthernWoods,
	SidingColor.OliveBranch,
	SidingColor.Rattan,
	SidingColor.Sandalwood,
	SidingColor.Sienna,
	SidingColor.SnowWhite,
	SidingColor.SunsetRed,
];

var colorMap: { [key in SidingColor]: string} = {
	[SidingColor.None]: "#FFFFFF",
	[SidingColor.BrickRed]: "#661b06",
	[SidingColor.Brownstone]: "#725c35",
	[SidingColor.Caramel]: "#725c35",
	[SidingColor.Chocolate]: "#40311a",
	[SidingColor.ColonialBlue]: "#495d68",
	[SidingColor.DustyClay]: "#7f7a66",
	[SidingColor.Ebony]: "#040700",
	[SidingColor.Eggshell]: "#fbfadc",
	[SidingColor.EmberGray]: "#686159",
	[SidingColor.Goldenrod]: "#c8bd87",
	[SidingColor.SilverGray]: "#a6a79f",
	[SidingColor.LibertyGray]: "#656e6d",
	[SidingColor.Moccasin]: "#e5e5b3",
	[SidingColor.Mocha]: "#1f2012",
	[SidingColor.MountainGreen]: "#1c442c",
	[SidingColor.NorthernWoods]: "#968c73",
	[SidingColor.OliveBranch]: "#766b4f",
	[SidingColor.Rattan]: "#b4b188",
	[SidingColor.Sandalwood]: "#d1c6aa",
	[SidingColor.Sienna]: "#81582a",
	[SidingColor.SunsetRed]: "#5f321b",
	[SidingColor.SnowWhite]: "#e5ece7",
	[SidingColor.TerraBronze]: "#4f4c39",
	[SidingColor.WinterSage]: "#636756",
	[SidingColor.DeepOceanBlue]: "#485c6b",
	[SidingColor.GrayWolf]: "#353731",
};

export function sentencize(pascalCasedString: string) {
	return pascalCasedString.replace(/([A-Z0-9])/g, " $1");// insert a space before all caps to make it readable.
}

export function colorNameMap(color: SidingColor) {
	return sentencize(SidingColor[color]);
}

export function typeNameMap(type: SidingType) {
	return sentencize(SidingType[type]);
}

export function hexCodeFor(color: SidingColor) {
	return colorMap[color];
}

export function imageUrlForColor(color: SidingColor, w: number, h: number) {
    let hexColor = hexCodeFor(color).replace("#", "");

  var p = new PNGlib(w, h, 256); // construcor takes height, weight and color-depth
  //p.color(0, 0, 0, 0); // set the background transparent

  var r = parseInt(hexColor[0] + hexColor[1], 16),
      g = parseInt(hexColor[2] + hexColor[3], 16),
      b = parseInt(hexColor[4] + hexColor[5], 16);

  for (var i = 0; i < w; i++) {
    for (var j = 0; j < h; j++) {
      p.buffer[p.index(i, j)] = p.color(r, g, b, (color === SidingColor.None) ? 0 : 255);
    }
  }


  return "data:image/png;base64,"+p.getBase64();
}


export class SidingSupportedConfigurations {
    SidingType: SidingType;
    Colors: SidingColor[];

    constructor(type: SidingType, colors: SidingColor[]) {
        this.SidingType = type;
        this.Colors = colors;
    }
}